import React from 'react'
import './styles.css'

const Loader = () => {
  return <div className="spinner">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/loader/index.js